/** 微信充值 /metering/finance/wechat-recharge（weChat.vue） */
export default {
  wechatRechargePage: {
    phDateStart: '开始时间',
    phDateEnd: '结束时间',
    phTenant: '租户名称/编号',
    btnSearch: '查询',
    btnReset: '重置',
    btnExport: '导出',
    sectionTitle: '微信充值',
    sortDefault: '默认排序',
    colSeqNo: '流水号',
    colOccurTime: '操作时间',
    colTenantName: '租户名',
    colRechargeAccount: '充值账号',
    colAmount: '充值金额',
    colFeeRate: '手续费费率',
    colFee: '手续费',
    colStatus: '状态',
    colAction: '操作',
    btnRefund: '退款',
    statusSuccess: '充值成功',
    statusFail: '充值失败',
    statusRevoked: '已撤销',
    shortcutYesterday: '昨天',
    shortcutThisWeek: '本周',
    shortcutLastWeek: '上周',
    shortcutThisMonth: '本月',
    shortcutLastMonth: '上月',
    shortcutLast3Months: '近三个月',
    shortcutLastYear: '近一年',
    msgTenantListFail: '获取租户列表失败',
    msgFetchFail: '获取数据失败',
    msgFetchRecordFail: '获取充值记录失败',
    msgNoDataExport: '暂无数据可导出',
    msgExportOk: '已导出 {count} 条',
    msgExportFail: '导出失败',
    exportSheetName: '微信充值',
    filePrefix: '微信充值',
    exportCurrentPage: '导出本页',
    exportSelected: '导出选中',
    exportAll: '导出全部',
    warnNoSelectedExport: '请先选择要导出的数据',
    msgExportOkSelected: '已导出选中 {count} 条',
    successExported: '已导出 {count} 条',
    successExportedLimit: '数据量超过 {total} 条，已导出前 {count} 条',
    exporting: '导出中...',
    msgRefundDev: '退款功能开发中…'
  }
}
